import api from '@/services/api.js';

export default {
    upload(formData){
        return api.post('/upload', formData);   
    },
    getOne(fileId){   
        return api.get('/upload/files/' + fileId);
    },
    delete(fileId){
        return api.delete('/upload/files/' + fileId);
    },
    download(url){
        return api.get(url, { responseType: 'arraybuffer' });
    }
}